import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../reducers/rootReducer';
import {
  dataConfigChartSelectors,
  getDataChartConfigFile,
} from '../../../reducers/dataConfigChartSlice';
import Preloader from '../../../components/Preloader/Preloader';
import { getErrorMessage } from '../../utils/getErrorMessage';

interface DataChartConfigGateProps {
  children: React.ReactNode;
}

export default function DataChartConfigGate({
  children,
}: DataChartConfigGateProps) {
  const dispatch = useDispatch();
  const { externalId } = useParams<{ externalId: string }>();

  const dataChartConfig = useAppSelector(
    dataConfigChartSelectors.selectConfigChartsData,
  );

  const hasError = useAppSelector(dataConfigChartSelectors.selectConfigError);
  const errorMessage = useAppSelector(
    dataConfigChartSelectors.selectConfigErrorMessage,
  );

  useEffect(() => {
    if (externalId) {
      dispatch(getDataChartConfigFile({ entityId: externalId }));
    }
  }, [externalId]);

  if (hasError) {
    return (
      <div style={{ padding: '20px', color: 'red' }}>
        Error loading chart configuration: {getErrorMessage(errorMessage)}
      </div>
    );
  }

  if (dataChartConfig.length === 0) {
    return <Preloader activeByDefault />;
  }

  return children;
}
